import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";
import { supportUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import { SupportAgentTicket } from "@src/types/support";

export const patchTicketMachine = async (
  namespace: string,
  ticketId: string,
  machineId: string,
) => {
  const url = supportUrlEnvVar();

  const headers = buildAxiosAuthenticationHeaders();

  try {
    const response = await axios.patch<SupportAgentTicket>(
      `${url}/api/v1/ns/${namespace}/tickets/${ticketId}`,
      { machine_id: machineId },
      {
        headers: headers,
      },
    );
    return response;
  } catch (err) {
    if (isAxiosError(err)) {
      console.error("Axios error:", err);
      throw err;
    } else {
      throw new Error(
        "An unexpected error occurred while updating ticket machine.",
      );
    }
  }
};
